module.exports = __webpack_public_path__ + "static/media/BackgroundLaptop.e28ecc38.png";